<template>
    <div class="page">
        <div class="workspace">
            <el-row :gutter="15">
                <el-col :span="12">
                    <company @change="onCompanyChange"/>
                </el-col>
                <el-col :span="12">
                    <technique :company="selectedCompany"/>
                    <el-divider></el-divider>
                    <demand :company="selectedCompany"/>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import Company from "./Company";
import Technique from './Technique.vue'
import Demand from './Demand.vue'

export default {
    components:{
        Company,
        Technique,
        Demand
    },
    data: function(){
        return {
            selectedCompany:null
        }
    },
    methods:{
        onCompanyChange(company){
            this.selectedCompany = company;
        }
    }
}
</script>